// Style for hiding an <input type="file"> while keeping it in the layout.
//
// Do NOT use `display: none` (or `visibility: hidden`) on file inputs that are
// opened by calling `inputRef.current.click()` from a button. Safari/WebKit
// (both desktop macOS and iOS) silently refuses to open the native file picker
// for an input that has no layout box, so the "Browse files" / "Take photo"
// buttons appear to do nothing. Chromium and Firefox don't have this
// restriction, which is why the bug only shows up on Safari/Mac.
//
// Drag-and-drop is unaffected by this because it reads
// `event.dataTransfer.files` and never triggers the input element.
//
// This is the same "visually hidden but present" technique MUI uses for its
// file-upload buttons.
export const visuallyHiddenFileInputStyle = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap',
  border: 0,
  bottom: 0,
  left: 0,
};

export default visuallyHiddenFileInputStyle;
